// extracted by mini-css-extract-plugin
module.exports = {"feedback":"index-feedback-1Qz8j","feedbackInner":"index-feedbackInner-3syp1","feedbackList":"index-feedbackList-2A7jp"};